import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DownloadStatusService, DownloadFile } from '../../services/download-status/download-status.service';


@Component({
  selector: 'app-download-status',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  templateUrl: './download-status.component.html',
  styleUrls: ['./download-status.component.scss']
})
export class DownloadStatusComponent {
  // Computed properties from service
  isVisible;
  isCollapsed;
  title;
  files;
  hasActiveDownloads;
  hasFailedDownloads;

  constructor(
    private downloadStatusService: DownloadStatusService
  ) {
    this.isVisible = this.downloadStatusService.isVisible;
    this.isCollapsed = this.downloadStatusService.isCollapsed;
    this.title = this.downloadStatusService.title;
    this.files = this.downloadStatusService.files;
    this.hasActiveDownloads = this.downloadStatusService.hasActiveDownloads;
    this.hasFailedDownloads = this.downloadStatusService.hasFailedDownloads;
  }

  // Computed properties for summary counts
  get activeCount(): number {
    return this.files().filter(f => f.status === 'InProgress').length;
  }

  get failedCount(): number {
    return this.files().filter(f => f.status === 'Failed').length;
  }

  get completedCount(): number {
    return this.files().filter(f => f.status === 'Completed').length;
  }

  // Methods that delegate to service
  toggleCollapse(): void {
    this.downloadStatusService.toggleCollapse();
  }

  close(): void {
    this.downloadStatusService.close();
  }

  removeFile(fileId: string): void {
    this.downloadStatusService.removeFile(fileId);
  }

  // Get status icon for a file
  getStatusIcon(file: DownloadFile): string {
    switch (file.status) {
      case 'InProgress':
        return 'hourglass_empty';
      case 'Completed':
        return 'check_circle';
      case 'Failed':
        return 'error';
      default:
        return 'file_download';
    }
  }

  // Get status color for a file
  private readonly statusColorMap: { [key: string]: string } = {
    'InProgress': 'primary',
    'Completed': 'success',
    'Failed': 'error'
  };

  getStatusColor(file: DownloadFile): string {
    return this.statusColorMap[file.status] || 'primary';
  }

  // Track by function for ngFor
  trackByFileId(index: number, file: DownloadFile): string {
    return file.id;
  }

  // Download file method - simple URL click
  downloadFile(file: DownloadFile): void {
    if (file.downloadUrl) {
      // Simple direct download from URL
      window.open(file.downloadUrl, '_blank');
    } else {
      console.error('No download URL found for file:', file.fileName);
    }
  }

  viewMore(): void {
    this.downloadStatusService.viewMore();
  }


} 